import LuggageIcon from '@mui/icons-material/Luggage';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Flex from 'frontend/commons/Flex';
import { useColors } from 'frontend/hooks/useColors';
import { Badge, Typography } from '@mui/material';
import './flightCard.css';

const TooltipContent = ({ checkedBag, background }) => {
  const getLuggageInfo = (count) => ({
    title: `${count > 1 ? 'equipajes' : 'equipaje'} de bodega`,
    description: 'Maleta a despachar en aeropuerto',
    textColor: count ? '#009e00' : '#dc3545',
  });

  const { title, description, textColor } = getLuggageInfo(checkedBag);

  return (
    <div className="tooltip-luggage-container">
      <Flex className="tooltip-luggage-item">
        <LuggageIcon
          className="tooltip-luggage-icon-large"
          sx={{ color: checkedBag ? background : '#dc3545' }}
        />
        <div className="tooltip-luggage-text">
          <Typography fontSize={12} fontWeight={300}>
            <span style={{ color: textColor }}>
              {checkedBag ? `Incluye ${checkedBag} ` : 'No incluye '}
            </span>
            <span style={{ color: '#000' }}>{title}</span>
          </Typography>
          <Typography fontSize={10} fontWeight={300} sx={{ color: '#000' }}>
            {description}
          </Typography>
        </div>
      </Flex>
    </div>
  );
};

const TooltipLuggage = ({ checkedBag = 0, iconColor: customIconColor }) => {
  const { background, gray } = useColors();
  const iconColor = customIconColor || (checkedBag ? background : gray);

  return (
    <Tooltip
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'transparent !important',
            padding: 0,
          },
        },
        popper: {
          sx: {
            '& .MuiTooltip-tooltip': {
              minWidth: 200,
            },
          },
        },
      }}
      title={<TooltipContent checkedBag={checkedBag} background={background} gray={gray} />}
    >
      <Box className="flight_card_info_third_row" sx={{ cursor: 'pointer' }}>
        <Flex>
          <Badge
            badgeContent={checkedBag}
            color="warning"
            sx={{
              '& .MuiBadge-badge': {
                fontSize: '0.75rem',
                minWidth: 18,
                height: 18,
                padding: '0 4px',
              },
            }}
          >
            <LuggageIcon
              sx={{
                fontSize: 28,
                color: iconColor,
                transition: 'fill 0.2s ease',
              }}
            />
          </Badge>
        </Flex>
      </Box>
    </Tooltip>
  );
};

export default TooltipLuggage;
